import request from '@/utils/request';

/**
 * 获取客户列表
 */
export function getProjects(params) {
  return request({
    url: '/api/project/list',
    method: 'get',
    params
  });
}

/**
 * 创建客户
 */
export function createProjects(data) {
  return request({
    url: '/api/project',
    method: 'post',
    data
  });
}

/**
 * 编辑客户
 */
export function editProject(id, data) {
  return request({
    url: '/api/project',
    method: 'put',
    params: {
      id
    },
    data
  });
}

/**
 * 获取审批流节点
 */
export function deleteProject(id) {
  return request({
    url: '/api/project',
    method: 'delete',
    params: {
      id
    }
  });
}
